module.exports = __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/rectangleConversionL_VA.bfe2d9ba.svg";